import axios from '../../../axios'

import { generalHelperMethodsMixin } from '../../mixins/generalHelperMethodsMixin'
import { editableTableMixin } from '../../mixins/editableTableMixin'

export const commentDataTableMixin = {
  mixins: [generalHelperMethodsMixin, editableTableMixin],
  methods: {
    async getStatusReportComments() {
      await this.retrieveComments()
      await this.mapUserIdToName()
      this.copyEntriesToTableData()
      this.filterOnVisibility()
      this.filterOnWeek()
      this.emitTableDataEvent()
    },

    //api call methods

    async retrieveComments() {
      const response = await axios.get(this.commentsURI, this.commentsParams) // this function is from the processPromises mixin
      this.fetchedData = response.data
    },

    copyEntriesToTableData() {
      this.tableData = this.fetchedData
        .map((item) => ({
          ...item,
          fullName: this.idToName[item.author],
          isEdit: false,
          isDelete: false
        }))
        .reverse()
    },

    filterOnVisibility() {
      this.tableData = this.tableData.filter(
        (comment) => this.commentIsForEveryone(comment) || this.commentIsForMeOnly(comment) || this.commentIsForSupervisorsOnly(comment)
      )
    },

    filterOnWeek() {
      if (this.week) {
        this.tableData = this.tableData.filter((comment) => this.getWeekNumber(comment.creation_date) === parseInt(this.week))
        return
      }
      this.copyEntriesToTableData()
      this.filterOnVisibility()
    },

    emitTableDataEvent() {
      this.$emit('tableData', this.tableData) //eslint-disable-line
    },
    commentIsForEveryone(comment) {
      return comment.visibility === 2
    },

    commentIsForMeOnly(comment) {
      return comment.visibility === 0 && comment.author === this.getUserId //eslint-disable-line
    },

    commentIsForSupervisorsOnly(comment) {
      return comment.visibility === 1 && this.getIsSupervisor //eslint-disable-line
    },

    addEntry() {
      // insert a dummy entry
      this.tableData.unshift({
        date: new Date(),
        content: '',
        author: this.getUserId,
        fullName: this.getFirstName,
        visibility: 0,
        isEdit: true,
        isDelete: false
      })
    },

    async confirmEditOrDelete(entry) {
      if (this.tableData[entry.index].isDelete) {
        this.deleteRow(entry.index)
        return
      } else if (this.isNewEntry(entry)) {
        const responseProjectId = await this.getProjectId

        const newEntry = {
          author: this.getUserId,
          content: this.tableData[entry.index].content,
          visibility: this.tableData[entry.index].visibility,
          project: responseProjectId,
          status_report: this.statusReportId
        }
        axios.post(`${this.commentsURI}/`, newEntry).then((response) => {
          this.tableData[entry.index].id = response.data.id
          this.fetchedData.push(response.data)
        })
      } else {
        const patchEntry = {
          content: this.tableData[entry.index].content,
          visibility: this.tableData[entry.index].visibility
        }
        const patchResponse = await axios.patch(`${this.commentsURI}/${this.tableData[entry.index].id}/`, patchEntry) // is necessary in order to avoid bugs when canceling the editing
        const indexOfPatchedEntry = this.findFetchedDataIndexById(patchResponse.data.id)
        if (indexOfPatchedEntry !== -1) {
          this.fetchedData[indexOfPatchedEntry] = patchResponse.data
        }
      }
      this.stopEditingOrDeleting(entry, true)
    },

    deleteRow(index) {
      const deletedId = this.tableData[index].id
      axios.delete(`${this.commentsURI}/${deletedId}/`)

      const indexOfDeletedEntry = this.findFetchedDataIndexById(deletedId)
      if (indexOfDeletedEntry !== -1) {
        this.fetchedData.splice(indexOfDeletedEntry, 1)
      }

      this.tableData.splice(index, 1)
    },

    stopEditingOrDeleting(entry, isConfirm = false) {
      // if it is called by cancel then it should refresh the data by calling copyEntriesToTableData
      this.tableData[entry.index].isDelete = false
      this.tableData[entry.index].isEdit = false

      isConfirm ? '' : this.copyEntriesToTableData()
    },

    commentIsByAuthor(entry) {
      return this.tableData[entry.index].author === this.getUserId
    }
  }
}
